import * as ActionTypes from '../constants/ActionTypes';
import API from '../helpers/api';

export function getTimeslots(query = {}) {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.GET_TIMESLOTS_REQUEST,
			payload: {
				loading: true
			}
		});

		const response = await API.timeslots.getTimeslots(query);
		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_TIMESLOTS_ERROR,
				payload: {
					loading: false,
					meta: response.meta
				}
			});
			return;
		}

		dispatch({
			type: ActionTypes.GET_TIMESLOTS_SUCCESS,
			payload: {
				loading: false,
				timeslots: response.data.timeslots || [],
				meta: response.meta
			}
		});
	};
}

export function getMeals(query = {}) {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.GET_MEALS_REQUEST,
			payload: {
				loadingMeals: true
			}
		});

		const response = await API.meals.getMeals(query);
		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_MEALS_ERROR,
				payload: {
					loadingMeals: false,
					meta: response.meta
				}
			});
			return;
		}

		dispatch({
			type: ActionTypes.GET_MEALS_SUCCESS,
			payload: {
				loadingMeals: false,
				meals: response.data.meals || [],
				meta: response.meta
			}
		});
	};
}

export function getDrinks() {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.GET_DRINKS_REQUEST,
			payload: {
				loadingDrinks: true
			}
		});

		const response = await API.drinks.getDrinks();
		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_DRINKS_ERROR,
				payload: {
					loadingDrinks: false,
					meta: response.meta
				}
			});
			return;
		}

		dispatch({
			type: ActionTypes.GET_DRINKS_SUCCESS,
			payload: {
				loadingDrinks: false,
				drinks: response.data.drinks || [],
				meta: response.meta
			}
		});
	};
}

export function createOrder(fields) {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.CREATE_ORDER_REQUEST,
			payload: {
				loadingCreatingOrder: true
			}
		});

		const body = {
			order: {
				...fields
			}
		};

		const response = await API.orders.createOrder(body);
		if (response.meta.code !== 200) {
			const errorMeta = response.data && response.data.error_code
				? { ...response.meta, error_code: response.data.error_code }
				: response.meta;
			dispatch({
				type: ActionTypes.CREATE_ORDER_ERROR,
				payload: {
					loadingCreatingOrder: false,
					meta: errorMeta
				}
			});
			return;
		}

		dispatch({
			type: ActionTypes.CREATE_ORDER_SUCCESS,
			payload: {
				loadingCreatingOrder: true,
				order: response.data.order || null,
				checkout_url: response.data.checkout_url || null,
				meta: response.meta
			}
		});

		// Redirect to external checkout URL
		if (response.data.checkout_url) {
			window.location.href = response.data.checkout_url;
		}
	};
}

export function getMealCustomizations(query) {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.GET_MEAL_CUSTOMIZATIONS_REQUEST,
			payload: {
				loadingMealCustomizations: true
			}
		});

		const response = await API.meals.getMealCustomizations(query);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_MEAL_CUSTOMIZATIONS_ERROR,
				payload: {
					loadingMealCustomizations: false,
					meta: response.meta
				}
			});
			return;
		}

		const { meal_customizations } = response.data;

		dispatch({
			type: ActionTypes.GET_MEAL_CUSTOMIZATIONS_SUCCESS,
			payload: {
				loadingMealCustomizations: false,
				mealCustomizations: meal_customizations
			}
		});
	};
}

export function getDrinkCustomizations(query) {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.GET_DRINK_CUSTOMIZATIONS_REQUEST,
			payload: {
				loadingDrinkCustomizations: true
			}
		});

		const response = await API.drinks.getDrinkCustomizations(query);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_DRINK_CUSTOMIZATIONS_ERROR,
				payload: {
					loadingDrinkCustomizations: false,
					meta: response.meta
				}
			});
			return;
		}

		const { drink_customizations } = response.data;

		dispatch({
			type: ActionTypes.GET_DRINK_CUSTOMIZATIONS_SUCCESS,
			payload: {
				loadingDrinkCustomizations: false,
				drinkCustomizations: drink_customizations
			}
		});
	};
}

export function clearMealCustomizations() {
	return dispatch => {
		dispatch({
			type: ActionTypes.CLEAR_MEAL_CUSTOMIZATIONS,
			payload: {
				loadingMealCustomizations: false,
				mealCustomizations: []
			}
		});
	};
}

export function clearDrinkCustomizations() {
	return dispatch => {
		dispatch({
			type: ActionTypes.CLEAR_DRINK_CUSTOMIZATIONS,
			payload: {
				loadingDrinkCustomizations: false,
				drinkCustomizations: []
			}
		});
	};
}

export function resetMeta() {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.RESET_BOOKING_META
		});
	};
}

export function resetPage() {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.RESET_BOOKING_PAGE
		});
	};
}
